import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { Checkbox, Radio } from '@primer/react';
import { MarkGithubIcon } from '@primer/octicons-react';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PropsTable = makeShortcode("PropsTable");
const PropsTableRow = makeShortcode("PropsTableRow");
const ComponentChecklist = makeShortcode("ComponentChecklist");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2>{`Deprecation`}</h2>
    <p>{`Use `}<a parentName="p" {...{
        "href": "/FormControl"
      }}>{`FormControl`}</a>{` instead.`}</p>
    <h2>{`Examples`}</h2>
    <h3>{`Checkbox`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live deprecated",
        "live": true,
        "deprecated": true
      }}>{`<ChoiceInputField>
  <ChoiceInputField.Label>Option one</ChoiceInputField.Label>
  <Checkbox />
</ChoiceInputField>
`}</code></pre>
    <h3>{`Radio`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live deprecated",
        "live": true,
        "deprecated": true
      }}>{`<fieldset style={{margin: 0, padding: 0, border: 0}}>
  <ChoiceInputField>
    <ChoiceInputField.Label>Option one</ChoiceInputField.Label>
    <Radio name="radioExample" value="one" />
  </ChoiceInputField>
  <ChoiceInputField>
    <ChoiceInputField.Label>Option two</ChoiceInputField.Label>
    <Radio name="radioExample" value="two" />
  </ChoiceInputField>
</fieldset>
`}</code></pre>
    <h3>{`Disabled field`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live deprecated",
        "live": true,
        "deprecated": true
      }}>{`<ChoiceInputField disabled>
  <ChoiceInputField.Label>Option one</ChoiceInputField.Label>
  <Checkbox />
</ChoiceInputField>
`}</code></pre>
    <h3>{`With a caption`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live deprecated",
        "live": true,
        "deprecated": true
      }}>{`<ChoiceInputField>
  <ChoiceInputField.Label>Option One</ChoiceInputField.Label>
  <Checkbox />
  <ChoiceInputField.Caption>Hint: the first and only option</ChoiceInputField.Caption>
</ChoiceInputField>
`}</code></pre>
    <h3>{`With a LeadingVisual`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live deprecated",
        "live": true,
        "deprecated": true
      }}>{`<>
  <ChoiceInputField>
    <ChoiceInputField.Label>Option one</ChoiceInputField.Label>
    <ChoiceInputField.LeadingVisual>
      <MarkGithubIcon />
    </ChoiceInputField.LeadingVisual>
    <Checkbox />
  </ChoiceInputField>

  <ChoiceInputField>
    <ChoiceInputField.Label>Option two</ChoiceInputField.Label>
    <ChoiceInputField.LeadingVisual>
      <MarkGithubIcon />
    </ChoiceInputField.LeadingVisual>
    <Checkbox />
    <ChoiceInputField.Caption>This one has a caption</ChoiceInputField.Caption>
  </ChoiceInputField>
</>
`}</code></pre>
    <h2>{`Props`}</h2>
    <h3>{`ChoiceInputField`}</h3>
    <p>{`The container that handles the layout and passes the relevant IDs and ARIA attributes it's children.`}</p>
    <p><inlineCode parentName="p">{`ChoiceInputField.Label`}</inlineCode>{` and `}<inlineCode parentName="p">{`ChoiceInputField.Input`}</inlineCode>{` are required children.`}</p>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="children" type="ChoiceInputField.Label | ChoiceInputField.Caption | ChoiceInputField.LeadingVisual | Checkbox | Radio" required mdxType="PropsTableRow" />
  <PropsTableRow name="disabled" type="boolean" defaultValue="false" description="Whether the field is ready for user input" mdxType="PropsTableRow" />
  <PropsTableRow name="id" type="string" defaultValue="a generated string" description="The unique identifier for this field. Used to associate the label, validation text, and caption text" mdxType="PropsTableRow" />
    </PropsTable>
    <h3>{`ChoiceInputField.Label`}</h3>
    <p>{`A `}<inlineCode parentName="p">{`ChoiceInputField.Label`}</inlineCode>{` must be passed, but it may be visually hidden.`}</p>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="children" type="React.ReactNode" description="The title that describes the choice input" mdxType="PropsTableRow" />
    </PropsTable>
    <h3>{`ChoiceInputField.Caption`}</h3>
    <p>{`If this field needs additional context, a `}<inlineCode parentName="p">{`ChoiceInputField.Caption`}</inlineCode>{` may be used to render hint text.`}</p>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="children" type="React.ReactNode" description="The content (usually just text) that is rendered to give contextual info about the field" mdxType="PropsTableRow" />
    </PropsTable>
    <h3>{`ChoiceInputField.LeadingVisual`}</h3>
    <p>{`If the selectable option would be easier to understand with a visual, the `}<inlineCode parentName="p">{`ChoiceInputField.LeadingVisual`}</inlineCode>{` component may be used.`}</p>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="children" type="React.ReactNode" description="The visual to render before the choice input's label" mdxType="PropsTableRow" />
    </PropsTable>
    <h2>{`Status`}</h2>
    <ComponentChecklist items={{
      propsDocumented: true,
      noUnnecessaryDeps: true,
      adaptsToThemes: true,
      adaptsToScreenSizes: true,
      fullTestCoverage: true,
      usedInProduction: false,
      usageExamplesDocumented: true,
      designReviewed: false,
      a11yReviewed: true,
      stableApi: false,
      addressedApiFeedback: false,
      hasDesignGuidelines: false,
      hasFigmaComponent: false
    }} mdxType="ComponentChecklist" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      